import React from "react";

/** Info bar showing key ticket fields at the top of the ticket detail. */
export default function TicketInfoBar({ ticket, cliente, stabilimento, extra = [] }) {
  const cells = [
    { label: "Ticket", value: <span className="info-value mono">{ticket.numero}</span> },
    ticket.codice_eg && { label: "N° E/G", value: <span className="info-value mono">{ticket.codice_eg}</span> },
    { label: "Cliente", value: <span className="info-value truncate" title={cliente?.ragione_sociale}>{cliente?.ragione_sociale || "—"}</span> },
    { label: "Stabilimento", value: <span className="info-value truncate" title={stabilimento?.nome}>{stabilimento?.nome || "—"}</span> },
    { label: "Urgente", value: ticket.urgente ? <span className="urgente-dot">Sì</span> : <span className="info-value text-slate-500">No</span> },
    ...extra,
  ].filter(Boolean);
  return (
    <div className="info-bar overflow-x-auto">
      {cells.map((c, i) => (
        <div key={i} className="info-cell">
          <div className="info-label">{c.label}</div>
          <div>{c.value}</div>
        </div>
      ))}
    </div>
  );
}
